var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({color: 'green'})},[_vm._v("AUTOPLAY:")]),_c('v-treeview',{attrs:{"items":_vm.itemsTree},scopedSlots:_vm._u([{key:"label",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(" "+_vm._s(item.name)+" : "),_c('strong',[_vm._v(" "+_vm._s(item.value))]),_vm._v(" "),_c('br')])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }